import { useMutation } from '@tanstack/react-query';

import { ordersRecognitionApi } from '@widgets/OrdersRecognition/api';
import { useSaveBudgetItemComment } from '@widgets/OrdersRecognition/api/hooks/useSaveBudgetItemComment';
import { useUpdateItemDate } from '@widgets/OrdersRecognition/api/hooks/useUpdateItemDate';

export const useCreateBudgetItem = () => {
    // const queryClient = useQueryClient();
    const saveBudgetItemCommentMutation = useSaveBudgetItemComment();
    const useUpdateItemDateMutation = useUpdateItemDate();

    return useMutation({
        mutationFn: ordersRecognitionApi.createBudgetItem,
        onSuccess: async (res, variables) => {
            console.log('success create budget item', res);
            console.log('create budget item variables', variables);

            // if (res?.data?.status === 'success') {
            //     await queryClient.invalidateQueries({
            //         queryKey: ordersRecognitionApi.getOrdersRecognitionListQueryOptions().queryKey,
            //     });
            //     onSuccessCb?.();
            // }
            await saveBudgetItemCommentMutation.mutateAsync({
                itemGuid: variables?.positionGuid,
                displayString: variables?.data?.comment,
            });

            if (variables?.data?.documentDate) {
                await useUpdateItemDateMutation.mutateAsync({
                    // itemGuid: variables?.positionGuid,
                    itemGuid: res?.data?.data?.guid,
                    documentDate: variables?.data?.documentDate,
                });
            }
        },
    });
};
